import { STATIONERY_GRID_PREVIEW_ASPECT_WH } from '~~/layers/base/constants/stationeryGridPreviewAspect'
import { buildCloudflareExternalImgUrl } from '~~/layers/base/utils/buildCloudflareExternalImgUrl'

/** Re-export for call sites that only need the default landscape 3∶2 aspect. */
export { STATIONERY_GRID_PREVIEW_ASPECT_WH }

/** Max width for scrolling-grid preview thumbs (matches liner grid width in `LinerField.vue`). */
const SCROLLING_GRID_THUMB_WIDTH_PX = 300

/**
 * Cloudflare resizing URL for a full stationery preview (`…/partPreview`) shown only in the
 * handwriting stationery ScrollingGrid (smaller payload than the raw delivery URL).
 *
 * Uses **`fit=scale-down`** with a max width × height box so the whole image scales down
 * inside the bounds (no `trim.*` crop — unlike liner thumbnails).
 *
 * @param aspectWidthOverHeight - Matches the UI tile (`referenceCanvasPx` ratio when set);
 *   defaults to 3∶2 (300×200 landscape previews).
 */
export function cloudflareScrollingGridThumbnailUrl(
    fullPreviewUrl: string,
    aspectWidthOverHeight: number = STATIONERY_GRID_PREVIEW_ASPECT_WH
): string {
    const w = SCROLLING_GRID_THUMB_WIDTH_PX
    const h = w / aspectWidthOverHeight
    return buildCloudflareExternalImgUrl(fullPreviewUrl.trim(), {
        quality: 75,
        width: w,
        height: Math.max(1, Math.round(h)),
        fit: 'scale-down',
    })
}
